import crypto from 'crypto'

let cachedScripts: string[] = []
let cachedDpl: string = ''

function GetDpl(scriptArr: string[]) {
  if (cachedScripts.length > 0) {
    return
  }

  cachedScripts.push(
    'https://cdn.oaistatic.com/_next/static/chunks/5474-f966e0e22a0e3d6d.js?dpl=f59798c3f023c05db0e1d05e937ea8eeda24cec9'
  )
  cachedDpl = 'dpl=f59798c3f023c05db0e1d05e937ea8eeda24cec9'
  const scripts: string[] = []
  let inited = false

  scriptArr.forEach((src) => {
    if (src.indexOf('cdn.oaistatic.com') !== -1) {
      scripts.push(src.split('?')[0])
      if (!inited) {
        const idx = src.indexOf('dpl')
        if (idx >= 0) {
          cachedDpl = src.substring(idx)
          inited = true
        }
      }
    }
  })

  if (scripts.length > 0) {
    cachedScripts = scripts
  }
}

interface ProofTokenConfig {
  required: boolean
  seed: string
  difficulty: string
  userAgent: string | null
  scriptArr: string[]
}

function getConfig(userAgent, scriptArr) {
  GetDpl(scriptArr)

  const screen =
    [16, 24, 32][Math.floor(Math.random() * 3)] +
    [3000, 4000, 6000][Math.floor(Math.random() * 3)]
  return [
    screen,
    `${new Date()}`,
    4294705152,
    0,
    userAgent,
    cachedScripts[Math.floor(Math.random() * cachedScripts.length)],
    cachedDpl,
    'en-US',
    'en-US,en',
    0,
    ['hardwareConcurrency−16', 'login−[object NavigatorLogin]'][
      Math.floor(Math.random() * 2)
    ],
    ['_reactListeningpa877jnmig', 'location'][Math.floor(Math.random() * 2)],
    ['alert', 'ontransitionend', 'onprogress'][Math.floor(Math.random() * 3)]
  ]
}

function generateAnswer(seed, difficulty, configArray): string | undefined {
  const diffLen = difficulty.length
  for (let i = 0; i < 500000; i++) {
    configArray[3] = i
    const jsonData = JSON.stringify(configArray)
    const base = Buffer.from(jsonData).toString('base64')
    const hash = crypto
      .createHash('sha3-512')
      .update(seed + base)
      .digest('hex')

    if (hash.substring(0, diffLen) <= difficulty) {
      return base
    }
  }

  const fallbackBase = Buffer.from(`"${seed}"`).toString('base64')
  return 'wQ8Lk5FbGpA2NcR9dShT6gYjU7VxZ4D' + fallbackBase
}

export function getProofToken(config: ProofTokenConfig) {
  const { seed, difficulty, userAgent, scriptArr } = config
  const configArray = getConfig(userAgent, scriptArr)
  const answer = generateAnswer(seed, difficulty, configArray)

  return 'gAAAAAB' + answer
}

export function getRequirementsToken(userAgent, scriptArr) {
  const configArray = getConfig(userAgent, scriptArr)
  const answer = generateAnswer(Math.random(), '0fffff', configArray)
  return 'gAAAAAC' + answer
}
